/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcription_ImportInputs */



/**
* | output |
* | --- |
* | "Transcription Import..." |
*
* @param {Transcription_ImportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcription_import = /** @type {((inputs?: Transcription_ImportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcription_ImportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation de transcription...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Transkriptimport...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione della trascrizione...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт транскрипции...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación de transcripción...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("转录导入...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("転写インポート...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिलेखन आयात...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação de transcrição...")
	return /** @type {LocalizedString} */ ("Transcription Import...")
});